export const subscriptionsQueryKeys = {
  subscription: () => ['subscription'],
  subscriptionDetails: () => [...subscriptionsQueryKeys.subscription(), 'details'],
};
